module.exports = __webpack_public_path__ + "img/ico-check-midnight-blue.848488ad.svg";